import React from "react";
import OperatorImage from "../images/OperatorImage";

export default function OperatorButton({isSelected=false, title, onClick, fileName}) {
    return <button key={title} className={"icon-btn operator"+ (isSelected ? " selected" : "")} title={title} onClick={onClick}>
        <OperatorImage fileName={fileName} title={title}/>
    </button>;
}